import { mapState } from 'vuex';
import {
  UPDATE_LOADING,
  MODIFY_THIRD_PARTY_PAYMENT_INFOS,
  GET_PRODUCT_LIST
} from '@store/officialTopupNew';

export default {
  data() {
    return {
      showAreaConfirmPopup: false, // 地区确认弹窗
      showZipCodeConfirmPopup: false, // zipcode确认弹窗
      areaErrorTips: '', // 错误提示
      areaErrorPopup: false, // 错误提示弹窗
      visibleAreaCommonTokenLoginPopup: false // 令牌登录弹窗
    };
  },
  computed: {
    ...mapState({
      isUidLogin: state => state.login.isUidLogin,
      locationModifyCount: state => state.locationModifyCount,
      maxLocationModifyCount: state => state.maxLocationModifyCount
    }),
    havePayWay() {
      return this.$store.state.locations
        ?.map?.(item => item.value)
        ?.includes?.(this.$store.state.curLocation);
    }
  },
  methods: {
    handleAreaConfirmPopup(state) {
      if (this.isUidLogin) {
        this.visibleAreaCommonTokenLoginPopup = true;
        return;
      }
      this.showAreaConfirmPopup = state;
    },
    handleZipCodeConfirmPopup(state) {
      this.showZipCodeConfirmPopup = state;
    },
    confirmSwitchArea(params) {
      this.$store.commit(UPDATE_LOADING, true);
      window.webstorev35DataLayer.push({
        eventName: 'bind_region',
        eventType: 'manualselect',
        eventReason: this.maxLocationModifyCount - this.locationModifyCount - 1,
        eventValue: params.location_code
      });
      this.$store
        .dispatch(MODIFY_THIRD_PARTY_PAYMENT_INFOS, params)
        .then(res => {
          this.$store.commit(UPDATE_LOADING, false);
          this.handleAreaConfirmPopup(false);
          this.handleZipCodeConfirmPopup(false);
          this.$store.dispatch(GET_PRODUCT_LIST);
        })
        .catch(errmsg => {
          this.$store.commit(UPDATE_LOADING, false);
          this.areaErrorTips = errmsg;
          this.areaErrorPopup = true;
        });
    }
  }
};
